import axios from 'axios';
import qs from 'qs';
import { URL, NOW, TOKEN } from '../utils/const';

/* 0945954 */
export const ctaCorriente = async (imponibleId) => {
    try {
        const emisiones = await axios({
            method: 'post',
            url: URL + 'opciones_pago_adelantado',
            data: qs.stringify({
                TOKEN: TOKEN,
                IMPONIBLE_ID: imponibleId,
                FECHA_ACTUALIZACION: NOW,
            }),
            headers: {
                'content-type': 'application/x-www-form-urlencoded;charset=utf-8',
            },
        });

        console.log(emisiones);

        if (emisiones.data.error) return emisiones.data;

        if (emisiones.data.items.length === 0) return -1;


        const recibo = await axios({
          method: 'post',
          url: URL + 'recibo_pago_adelantado',
          data: qs.stringify({
              TOKEN: TOKEN,
              IMPONIBLE_ID: imponibleId,
              TR03430_ID: emisiones.data.items[0].tr03430_id,
          }),
          headers: {
              'content-type': 'application/x-www-form-urlencoded;charset=utf-8',
          },
      });

        const emisionesPdf = await axios({
            method: 'post',
            url: URL + 'recibo_pdf',
            data: qs.stringify({
                TOKEN: TOKEN,
                RECIBO_NRO: recibo.data.items[0].recibo,
            }),
            headers: {
                'content-type': 'application/x-www-form-urlencoded;charset=utf-8',
            },
            responseType: 'blob',
        });

        if (emisionesPdf.data.error) return emisiones.data;
        return {
            blob: emisionesPdf.data,
            data: { IMPONIBLE_ID: imponibleId, TR1E200_ID: emisiones.data.items[0].tr1e200_id },
        };
    } catch (error) {
        return error;
    }
};
